import { CSSObject } from '@chakra-ui/react';
import locationUnavailable from '../../../assets/puntcity/images/backgrounds/locationUnavailable.png';
import locationUnavailableMobile from '../../../assets/puntcity/images/backgrounds/locationUnavailableMobile.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100dvh',
};

export const CenterWrapper: CSSObject = {
  alignItems: 'center',
  bg: [
    `url(${locationUnavailableMobile}) center/cover no-repeat`,
    null,
    `url(${locationUnavailable}) center/cover no-repeat`,
  ], // Bespoke colour from background image
  borderRadius: [null, null, 'xl'],
  boxShadow: [null, null, '0 8px 30px rgba(0, 0, 0, .2)'],
  color: 'white',
  contain: 'paint',
  flex: ['1', null, '0 1 auto'],
  gap: '0',
  h: undefined,
  justifyContent: 'start',
  maxW: 'container.md',
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  pt: ['32', null, 'unset'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'accent',
  fontSize: ['3xl', null, '4xl'],
  pb: '6',
  pt: ['60', null, '4'],
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '95%',
  textTransform: 'capitalize',

  bgGradient: 'linear(to-b, gamma.300, gamma.500)',
  bgClip: 'text',
  color: 'transparent',
  pr: '1',
};

export const ContentBodyText: CSSObject = {
  fontSize: 'sm',
  mb: '4',
  textAlign: 'center',

  b: {
    display: 'block',
    fontWeight: 'extrabold',
    mb: '4',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '15px',
    fontStyle: 'normal',
    lineHeight: '18px',
    color: 'delta.500',
  },

  '.chakra-link': {
    fontSize: 'sm',
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
};
